import script from "./CollectionsNav.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsNav.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsNav.vue?vue&type=style&index=0&id=24bba6c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bba6c9"]])

export default __exports__